const ROLE_ALIASES = { cs: 'cs_admin', admin: 'org_admin' }

export function resolveCSRole(user, staffRoles = []) {
  if (user?.organization_permission !== 'super_admin') return user?.organization_permission === 'admin' ? 'org_admin' : 'user'
  const id = String(user?.pk ?? user?.id ?? '')
  const active = staffRoles.filter(row => String(row.user_id) === id && row.is_active === true && row.account_active === true && row.license_active === true)
  if (active.some(row => row.role === 'cs')) return 'cs_admin'
  if (active.some(row => row.role === 'technical')) return 'technical'
  if (user?.organization_permission === 'super_admin') return 'staff_admin'
  return ROLE_ALIASES[user?.organization_permission] || 'user'
}

export function csIssueCapabilities(role) {
  const cs = role === 'cs_admin'
  const technical = role === 'technical'
  const customer = role === 'user' || role === 'org_admin'
  return {
    canViewIssues: cs || technical || customer, canCreateIssue: cs || customer,
    canEditIssue: cs || customer, canEditOperations: cs,
    canAddPublicComment: cs || customer, canAddInternalNote: cs || technical,
    canAssign: cs, canCorrectStatus: cs, canManageRoles: role === 'staff_admin' || cs || technical,
    canDownloadPublicAttachment: cs || customer, canDownloadInternalAttachment: cs || technical,
  }
}

export function allowedCSIssueStatusActions(role, statusCode) {
  if (role === 'cs_admin') return [...(statusCode === 'checking' ? ['start_work'] : []), ...(statusCode === 'closed' ? ['reopen'] : ['force_close'])]
  if ((role === 'user' || role === 'org_admin') && statusCode === 'waiting_resolution') return ['confirm_resolution', 'report_unresolved']
  if ((role === 'user' || role === 'org_admin') && statusCode === 'closed') return ['reopen']
  return []
}
